import { getIntlAnalyticsContext } from "./analyticsContext.js";
import { localeToLanguage, normalizeLocale } from "./localeResolution.js";
import { normalizeDisplayCurrency } from "./currencyResolution.js";
import { getManifestMarket, localeToUrlSegment } from "./manifestI18n.js";

function detectBrowserLocale() {
  if (typeof navigator !== "undefined" && navigator.language) {
    return normalizeLocale(navigator.language);
  }
  return "es-CO";
}

function detectAcceptLanguageHeader() {
  return null;
}

/**
 * Resolve locale/currency metadata for public form submissions.
 * Prefers active Client View intl context, then explicit overrides, then browser defaults.
 */
export function resolveSubmissionIntlContext(overrides = {}) {
  const analytics = getIntlAnalyticsContext();
  const locale = normalizeLocale(overrides.locale || analytics.locale || detectBrowserLocale());
  const displayCurrency = normalizeDisplayCurrency(
    overrides.displayCurrency || analytics.displayCurrency || "COP"
  );

  return {
    locale,
    language: overrides.language || localeToLanguage(locale),
    displayCurrency,
    routeLocale:
      overrides.routeLocale ||
      analytics.routeLocale ||
      localeToUrlSegment(locale) ||
      null,
    clientViewSlug: overrides.clientViewSlug || analytics.clientViewSlug || null,
    marketCode: overrides.marketCode || analytics.marketCode || null,
    marketCountry: overrides.marketCountry || analytics.marketCountry || null,
    priceStorageCurrency: overrides.priceStorageCurrency || analytics.priceStorageCurrency || null,
    fallbackLocale: overrides.fallbackLocale || analytics.fallbackLocale || null,
    resolvedLocale: locale,
  };
}

export { detectBrowserLocale, detectAcceptLanguageHeader };
